/**
 * Unit 1.4 · IMPL.E: loading skeleton, 3 row pulses in the 5-column shape.
 * No "Loading…" text anywhere (design brief).
 */
import { TableBody, TableCell, TableRow } from "@/components/ui/table";

const CELL_WIDTHS = ["w-48", "w-10", "w-10", "w-10", "w-24"];

export function ClientListSkeleton() {
    return (
        <TableBody>
            {[0, 1, 2].map((row) => (
                <TableRow key={row}>
                    {CELL_WIDTHS.map((width, col) => (
                        <TableCell key={col} colSpan={col === 4 ? 2 : 1}>
                            {/* bg-muted/60: the document-library pulse tone
                                (Unit 4 parity brief, D10). */}
                            <span
                                className={`bg-muted/60 block h-4 animate-pulse rounded ${width}`}
                            />
                        </TableCell>
                    ))}
                </TableRow>
            ))}
        </TableBody>
    );
}
